/**
 * 菜单与权限 store 模块
 * 功能：拉取菜单/按钮权限存入 localStorage 与 state，保存用户 id/姓名
 */
import {
    getMenuList,
    getButton
} from "@/api/auth"
const menuList = {
    state: {
        menuList: [], //所有菜单
        allButton: [],
        isButtonAuth: false,
        userId: "",  // 获取当前登录用户id
        userName: ""
    },
    getters: {
        menuList: state => state.menuList,
        allButton: state => state.allButton,
        isButtonAuth: state => state.isButtonAuth,
        userId: state => state.userId,
        userName: state => state.userName,
    },
    mutations: {
        SET_MENU_LIST: (state, data) => {
            state.menuList = data;
        },
        SET_BUTTON_AUTH: (state, data) => {
            state.allButton = data;
        },
        GET_BUTTON_AUTH: (state, data) => {
            state.isButtonAuth = data;
        },
        GET_USER_ID: (state, data) => {
            state.userId = data;
        },
        GET_USER_NAME: (state, data) => {
            state.userName = data;
        },
    },
    actions: {
        //获取菜单按
        getButtonList: ({
            commit
        }, data) => {
            if (data.path != '/' && data.path != '/homePage') {
                let para = {
                    resource_path: data.path
                }
                getButton(para).then((result) => {
                    let resource = result.data;
                    if (resource.length > 0) {
                        localStorage.setItem(data.name + '_button', JSON.stringify(resource));
                        commit("SET_BUTTON_AUTH", resource);
                        commit("GET_BUTTON_AUTH", resource.length > 0 ? true : false);
                    } else {
                        localStorage.setItem(data.name + '_button', JSON.stringify([]));
                    }

                })
            }


        },
        // 获取菜单 
        getMenuList: ({
            commit
        }) => {
            getMenuList().then(result => {
                if (result.code == 0) {
                    let routes = result.data.permissions;
                    localStorage.setItem("router", JSON.stringify(routes));
                    commit("SET_MENU_LIST", routes);
                    commit("GET_USER_ID", result.data.id);
                    commit("GET_USER_NAME", result.data.name);
                    window.localStorage.setItem("username", result.data.name)
                }
            });
        }

    }
};

export default menuList